import React from 'react';
import { useTheme } from '@mui/material/styles';
import { getWeightedColor, getWeightedColorAlt, isNumber } from '../../../../utils/utils';
import NRHighlightedText from '../../../../components/NRHighlightedText/NRHighlightedText';

const AI_MODEL_CATEGORY_LABELS = {
  AI_MODEL_CATEGORY_UNSPECIFIED: 'Unspecified',
  AI_MODEL_CATEGORY_LLM: 'Large Language Model',
  AI_MODEL_CATEGORY_BIOMETRIC: 'Biometric',
  AI_MODEL_CATEGORY_DIFFUSION: 'Diffusion',
  AI_MODEL_CATEGORY_IMAGE_SEGMENTATION: 'Image Segmentation',
  AI_MODEL_CATEGORY_OBJECT_DETECTION: 'Object Detection',
  AI_MODEL_CATEGORY_OBJECT_TRACKING: 'Object Tracking'
};

const parseAiModelCategory = modelCategory => {
  if (!modelCategory) return '';
  return AI_MODEL_CATEGORY_LABELS[modelCategory] || modelCategory;
};

function NRAiModelCategorySeverity({ severity, modelCategory }) {
  const theme = useTheme();
  const safeSeverity = isNumber(severity) ? severity : 0;
  const weightedColor = getWeightedColor(safeSeverity, theme);
  const weightedColorAlt = getWeightedColorAlt(safeSeverity, theme);
  const parsedModelCategory = parseAiModelCategory(modelCategory);

  return (
    <NRHighlightedText
      color={weightedColor}
      colorAlt={weightedColorAlt}
      backgroundColor={weightedColor}
      textAlphaValue={isNumber(severity) ? 1 : 0.56}
      highlightAll={true}
      text={parsedModelCategory}
      alphaValue={0.15}
      showBorder={true}
      minWidth={'150px'}
      justifyContent={'flex-start'}
      fontSize={12}
      lineHeight={14}
    />
  );
}

export default NRAiModelCategorySeverity;
